// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSection_heroSection__sFhxj","heroSection__carousel":"HeroSection_heroSection__carousel__9bzgN","heroSection__info":"HeroSection_heroSection__info__EJK36"};